import { RRule, RRuleSet, rrulestr } from 'rrule';

import RRPT from 'constants/recurrence/recurrenceRuleParseType.const';
import RRS from 'constants/recurrence/recurrenceRuleSimplified.const';
import { fromAnyDateToDate, fromAnyDateToIso, fromAnyDateToIsoDayEnd } from 'utils/converters/time/from.util';
import withOptions from 'utils/functions/withOptions.util';
import logger from 'utils/logger.util';
import { isTimeAfter } from 'utils/predicates/time/compare.util';

const L = logger('constructRecurrenceString');

const parse = withOptions(({ rrs }) => {
  const WEEKLY = RRule.WEEKLY;
  const DAILY = RRule.DAILY;

  if (rrs === RRS.onlyOnce) return { freq: null, interval: null };
  if (rrs === RRS.every1Day) return { freq: DAILY, interval: null };
  if (rrs === RRS.every1Week) return { freq: WEEKLY, interval: null };
  if (rrs === RRS.every2Weeks) return { freq: WEEKLY, interval: 2 };
  if (rrs === RRS.every3Weeks) return { freq: WEEKLY, interval: 3 };
  if (rrs === RRS.every4Weeks) return { freq: WEEKLY, interval: 4 };
  if (rrs === RRS.every6Weeks) return { freq: WEEKLY, interval: 6 };

  return { freq: null, interval: null };
});

const normal = withOptions(({ rrs, string, bgn, end, repeatForever: forever }) => {
  const bgnIso = fromAnyDateToIso(bgn);
  const endIso = fromAnyDateToIso(end);

  if (!string && !(bgn && (end || forever))) {
    return L.warn('()', 'Bad ', { bgn, end, string, forever }, 'returning:', '');
  }

  const { freq, interval } = parse({ rrs, type: RRPT.normal });
  if (!freq) return L.debug('normal()', 'No freq:', freq, 'in rrs:', rrs, 'returning:', '');

  // TODO: find a better way to clear the old rules and preserve the exclusions and exdates

  const ruleSet = new RRuleSet();
  const parsedRule = string ? rrulestr(string) : null;
  if (parsedRule) ruleSet.rrule(parsedRule);

  // noinspection JSConstantReassignment
  ruleSet._rrule = []; // eslint-disable-line no-underscore-dangle

  const o = { freq };

  if (interval) o.interval = interval;
  if (bgnIso) o.dtstart = fromAnyDateToDate(bgnIso);
  if (!bgnIso && parsedRule) o.dtstart = parsedRule.options.dtstart;
  if (!(bgnIso && endIso) && parsedRule) o.until = parsedRule.options.until;

  if (bgnIso && endIso && forever === false && isTimeAfter(endIso, bgnIso)) {
    o.until = fromAnyDateToDate(fromAnyDateToIsoDayEnd(endIso));
  }

  ruleSet.rrule(new RRule(o));

  return ruleSet.valueOf().join('\n');
});

const constructRecurrenceString = normal;

constructRecurrenceString.normal = normal;

export default constructRecurrenceString;
